import { c as _c } from "react/compiler-runtime";
import { CheckUp } from "@/app/components/ReasonForVisit/CheckUp";
import { DentalImplants } from "@/app/components/ReasonForVisit/DentalImplants";
import { BrokenTooth } from "@/app/components/ReasonForVisit/BrokenTooth";
import { MottoAligners } from "@/app/components/ReasonForVisit/MottoAligners";
import { Emergency } from "@/app/components/ReasonForVisit/Emergency";
import { Dentures } from "@/app/components/ReasonForVisit/Dentures";
import { MuiIcon } from "@/app/components/studio/MuiIcon";
import { Button, ListItemIcon, ListItemText, Menu, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { JSX, useState } from "react";
import styles from "./ReasonForVisit.module.css";
import { DIGITAL_VISIT_REASONS, type DigitalVisitReason } from "@/lib/constants/digitalVisitReasons";
interface IReasonForVisitProps {
  reasonForVisit: string;
  handleReasonForVisitChange: (event: any) => void;
  id: string;
  className?: string;
}
type ReasonForVisitOption = {
  key: DigitalVisitReason;
  label: string;
  value: string;
  icon: JSX.Element;
  iconForHero: JSX.Element;
};
export const REASON_FOR_VISITS: ReasonForVisitOption[] = [{
  key: DIGITAL_VISIT_REASONS.Dentures,
  label: "Dentures",
  value: "dentures",
  icon: <Dentures />,
  iconForHero: <Dentures width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.Implants,
  label: "Dental Implants",
  value: "implants",
  icon: <DentalImplants />,
  iconForHero: <DentalImplants width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.ClearAligners,
  label: "Motto™ Clear Aligners",
  value: "mottoaligners",
  icon: <MottoAligners />,
  iconForHero: <MottoAligners width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.Emergency,
  label: "Emergency",
  value: "emergency",
  icon: <Emergency />,
  iconForHero: <Emergency width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.BrokenToothToothPain,
  label: "Broken Tooth/Tooth Pain",
  value: "brokentooth-toothpain",
  icon: <BrokenTooth />,
  iconForHero: <BrokenTooth width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.Other,
  label: "Other/Check Up",
  value: "other",
  icon: <CheckUp />,
  iconForHero: <CheckUp width={44} height={44} />
}];
export const REASON_FOR_VISITS_ODP: ReasonForVisitOption[] = [{
  key: DIGITAL_VISIT_REASONS.Emergency,
  label: "Emergency",
  value: "emergency",
  icon: <Emergency />,
  iconForHero: <Emergency width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.BrokenToothToothPain,
  label: "Broken Tooth/Tooth Pain",
  value: "brokentooth-toothpain",
  icon: <BrokenTooth />,
  iconForHero: <BrokenTooth width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.Implants,
  label: "Dental Implants",
  value: "implants",
  icon: <DentalImplants />,
  iconForHero: <DentalImplants width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.Dentures,
  label: "Dentures",
  value: "dentures",
  icon: <Dentures />,
  iconForHero: <Dentures width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.ClearAligners,
  label: "Motto™ Clear Aligners",
  value: "mottoaligners",
  icon: <MottoAligners />,
  iconForHero: <MottoAligners width={44} height={44} />
}, {
  key: DIGITAL_VISIT_REASONS.Other,
  label: "Other/Check Up",
  value: "other",
  icon: <CheckUp />,
  iconForHero: <CheckUp width={44} height={44} />
}];
export const ReasonForVisit = t0 => {
  const $ = _c(31);
  const {
    reasonForVisit,
    handleReasonForVisitChange,
    id,
    className
  } = t0;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      setAnchorEl(event.currentTarget);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleClick = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setAnchorEl(null);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  let t3;
  if ($[2] !== handleReasonForVisitChange) {
    t3 = (event_0, value) => {
      handleReasonForVisitChange({
        target: {
          value
        }
      });
      handleClose();
    };
    $[2] = handleReasonForVisitChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleMenuItemClick = t3;
  let t4;
  if ($[4] !== reasonForVisit) {
    t4 = REASON_FOR_VISITS.find(reason => reason.value === reasonForVisit);
    $[4] = reasonForVisit;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const selectedReason = t4;
  const t5 = open ? "reason-menu" : undefined;
  const t6 = open ? "true" : "false";
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MuiIcon iconName="keyboard_arrow_down" />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = `${styles.reasonSelectButton} ${className || ""}`;
  const t9 = selectedReason ? selectedReason.label : "Reason for visit";
  let t10;
  if ($[7] !== t9) {
    t10 = <Typography variant="bodyS">{t9}</Typography>;
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== id || $[10] !== t10 || $[11] !== t5 || $[12] !== t6 || $[13] !== t8) {
    t11 = <Button id={id} aria-controls={t5} aria-haspopup="true" aria-expanded={t6} onClick={handleClick} endIcon={t7} className={t8} fullWidth={true} suppressHydrationWarning={true}>{t10}</Button>;
    $[9] = id;
    $[10] = t10;
    $[11] = t5;
    $[12] = t6;
    $[13] = t8;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  let t13;
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      vertical: "bottom",
      horizontal: "left"
    };
    t13 = {
      vertical: "top",
      horizontal: "left"
    };
    t14 = {
      className: styles.reasonMenuPaper
    };
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
  } else {
    t12 = $[15];
    t13 = $[16];
    t14 = $[17];
  }
  let t15;
  if ($[18] !== id) {
    t15 = {
      paper: t14,
      list: {
        className: styles.reasonMenuList,
        "aria-labelledby": id
      }
    };
    $[18] = id;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== handleMenuItemClick || $[21] !== reasonForVisit) {
    t16 = REASON_FOR_VISITS.map(reason_0 => {
      const isSelected = reason_0.value === reasonForVisit;
      return <MenuItem key={reason_0.value} selected={isSelected} onClick={event_1 => handleMenuItemClick(event_1, reason_0.value)} id={reason_0.value} className={`${styles.reasonMenuItem}${isSelected ? " " + styles.selected : ""}`}><ListItemIcon>{reason_0.icon}</ListItemIcon><ListItemText primary={reason_0.label} slotProps={{
          primary: {
            variant: "bodyM"
          }
        }} /></MenuItem>;
    });
    $[20] = handleMenuItemClick;
    $[21] = reasonForVisit;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== anchorEl || $[24] !== open || $[25] !== t15 || $[26] !== t16) {
    t17 = <Menu id="reason-menu" anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={t12} transformOrigin={t13} slotProps={t15}>{t16}</Menu>;
    $[23] = anchorEl;
    $[24] = open;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t11 || $[29] !== t17) {
    t18 = <>{t11}{t17}</>;
    $[28] = t11;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
};